import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import LoginForm from '../components/auth/LoginForm';

import '../assets/scss/admin-panel.scss';
import AuthStore from '../store/auth/AuthStore';
import OTPForm from '../components/auth/OTPForm';
import Header from '../components/common/Header';
import AdminStore from '../store/AdminStore';
import RatingStore from '../store/RatingStore';
import { formatTime } from '../utils/utils';

const getUser = (id: string): string => {
  const user = AdminStore.users.find(x => x.ID === id);

  if (!user) return "Не найден";

  return `${user.NickName !== undefined ? `${user.NickName} (${user.ShortID})` : user.ShortID}`;
}

const getMap = (id: string) => {
  const map = RatingStore.maps.find(x => x.ID === id);

  if (!map) return <>Не найдена</>;

  return <>{map.Title}</>;
}

const AdminPanelPage: React.FC = observer(() => {
  const [fetched, setFetched] = useState(false);
  
  useEffect(() => {
    if (!fetched) {
      RatingStore.fetchMaps();
      AdminStore.fetchUsers();
      AdminStore.fetchGames();
      AdminStore.fetchWarpointGames();
      AdminStore.fetchBeatSaberGames();
      setFetched(true);
    }
  }, [fetched, setFetched]);

  return (
    <>
      <Header />
      <div className="container">
        <div className="rating-btns">
          <button className={AdminStore.rating == "Assetto Corsa" ? 'rating-btn selected' : 'rating-btn'} onClick={() => AdminStore.setRating("Assetto Corsa")}>Assetto Corsa</button>
          <button className={AdminStore.rating == "Warpoint" ? 'rating-btn selected' : 'rating-btn'} onClick={() => AdminStore.setRating("Warpoint")}>Warpoint</button>
          <button className={AdminStore.rating == "Beat Saber" ? 'rating-btn selected' : 'rating-btn'} onClick={() => AdminStore.setRating("Beat Saber")}>Beat Saber</button>
        </div>
      </div>
      {AdminStore.rating === "Assetto Corsa" ? 
        <>
        <div className='sr__adminPanel'>
          <div className='sr__adminPanel__input'>
            <select name="users" id="users">
              {AdminStore.users.map((user) => {
                return (
                  <option key={user.ID} value={user.ID}>{user.NickName !== undefined ? `${user.NickName} (${user.ShortID})` : user.ShortID} </option>
                );
              })}
            </select>
          </div>
          <div className='sr__adminPanel__input'>
            <select name="maps" id="maps">
              {RatingStore.maps.map((map) => {
                return (
                  <option key={map.ID} value={map.ID}>{map.Title}</option>
                );
              })}
            </select>
          </div>
          <div className='sr__adminPanel__input'>
            <input
              className='sr__adminPanel__textField'
              id='time'
              inputMode='text'
              name='time'
              autoComplete='time'
              placeholder='00:00.000'
              type='text'
            />
          </div>
          <div className='sr__adminPanel__input'>
            <input
              className='sr__adminPanel__textField'
              inputMode='numeric'
              id='prize'
              name='prize'
              autoComplete='prize'
              placeholder='Сумма в призовой фонд'
              type='text'
            />
          </div>
          <button
            className='sr__adminPanel__button'
            style={{ marginBottom: '0' }}
            onClick={() => AdminStore.onClick()}
          >Продолжить</button>
        </div>

        <div className="games_list">
          {AdminStore.games.map((game) => {
            return <div className="games_item" key={`${game.ID}_mobile`}>
              <div className="games_item-header" onClick={() => game.Opened = !game.Opened }>
                <p>{getUser(game.UserID).length < 24 ? getUser(game.UserID) : `${getUser(game.UserID).slice(0, 25)}...`}</p>
                <p>{formatTime(game.Time)}</p>
              </div>
              <div className="games_item-body" style={{ display: game.Opened ? 'block' : 'none' }}>
                <p>ID: <b>{game.ID}</b></p>
                <p>Игрок: <b>{getUser(game.UserID)}</b></p>
                <p>Карта: <b>{getMap(game.MapID)}</b></p>
                <p>Время: <b>{formatTime(game.Time)}</b></p>
                <p>В банк: <b>{game.Prize}</b></p>
              </div>
            </div>
          })}
        </div>
        <div className="container" style={{ marginTop: '0' }}>
          <table className="games_table" style={{ marginTop: '0' }}>
            <thead>
              <tr className="games_table-header">
                <th>ID</th>
                <th style={{ width: '256px' }}>Время</th>
                <th style={{ width: '320px' }}>Игрок</th>
                <th style={{ width: '360px' }}>Карта</th>
                <th style={{ width: '160px' }}>В банк</th>
              </tr>
            </thead>
          </table>
          <div className="table-body">
            <table className="games_table">
              <tbody>
                {AdminStore.games.map((game) => {
                  return <tr className="games_table-row" key={game.ID}>
                    <td className="table_column-id"><button onClick={() => AdminStore.deleteGame(game.ID)}>Удалить</button>{game.ID}</td>
                    <td style={{ width: '256px' }} className="table_column-time">{formatTime(game.Time)}</td>
                    <td style={{ width: '320px' }} className="table_column-user">{getUser(game.UserID)}</td>
                    <td style={{ width: '360px' }} className="table_column-map">{getMap(game.MapID)}</td>
                    <td style={{ width: '160px' }} className="table_column-prize">{game.Prize}</td>
                  </tr>
                })}
              </tbody>
            </table>
          </div>
        </div>
        </> : <></>
        }

        {AdminStore.rating === "Warpoint" ? 
          <>
          <div className='sr__adminPanel'>
            <div className='sr__adminPanel__input'>
              <select name="users" id="users">
                {AdminStore.users.map((user) => {
                  return (
                    <option key={user.ID} value={user.ID}>{user.NickName !== undefined ? `${user.NickName} (${user.ShortID})` : user.ShortID} </option>
                  );
                })}
              </select>
            </div>
            <div className='sr__adminPanel__input'>
              <input
                className='sr__adminPanel__textField'
                id='kills'
                inputMode='text'
                name='kills'
                autoComplete='kills'
                placeholder='Убийства'
                type='text'
              />
            </div>
            <div className='sr__adminPanel__input'>
              <input
                className='sr__adminPanel__textField'
                id='deaths'
                inputMode='text'
                name='deaths'
                autoComplete='deaths'
                placeholder='Смерти'
                type='text'
              />
            </div>
            <button
              className='sr__adminPanel__button'
              style={{ marginBottom: '0' }}
              onClick={() => AdminStore.onClickWarpoint()}
            >Продолжить</button>
          </div>

          <div className="games_list">
            {AdminStore.warpointGames.map((game) => {
              return <div className="games_item" key={`${game.ID}_mobile`}>
                <div className="games_item-header" onClick={() => game.Opened = !game.Opened }>
                  <p>{getUser(game.UserID).length < 24 ? getUser(game.UserID) : `${getUser(game.UserID).slice(0, 25)}...`}</p>
                  <p>{game.Kills}/{game.Deaths}</p>
                </div>
                <div className="games_item-body" style={{ display: game.Opened ? 'block' : 'none' }}>
                  <p>ID: <b>{game.ID}</b></p>
                  <p>Игрок: <b>{getUser(game.UserID)}</b></p>
                  <p>Убийства: <b>{game.Kills}</b></p>
                  <p>Смерти: <b>{game.Deaths}</b></p>
                </div>
              </div>
            })}
          </div>
          <div className="container" style={{ marginTop: '0' }}>
            <table className="games_table" style={{ marginTop: '0' }}>
              <thead>
                <tr className="games_table-header">
                  <th>ID</th>
                  <th style={{ width: '256px' }}>Игрок</th>
                  <th style={{ width: '320px' }}>Убийства</th>
                  <th style={{ width: '360px' }}>Смерти</th>
                </tr>
              </thead>
            </table>
            <div className="table-body">
              <table className="games_table">
                <tbody>
                  {AdminStore.warpointGames.map((game) => {
                    return <tr className="games_table-row" key={game.ID}>
                      <td className="table_column-id"><button onClick={() => AdminStore.deleteWarpoint(game.ID)}>Удалить</button>{game.ID}</td>
                      <td style={{ width: '256px' }} className="table_column-user">{getUser(game.UserID)}</td>
                      <td style={{ width: '320px' }} className="table_column-user">{game.Kills}</td>
                      <td style={{ width: '360px' }} className="table_column-map">{game.Deaths}</td>
                    </tr>
                  })}
                </tbody>
              </table>
            </div>
          </div>
          </> : <></>
        }

        {AdminStore.rating === "Beat Saber" ? 
          <>
          <div className='sr__adminPanel'>
            <div className='sr__adminPanel__input'>
              <select name="users" id="users">
                {AdminStore.users.map((user) => {
                  return (
                    <option key={user.ID} value={user.ID}>{user.NickName !== undefined ? `${user.NickName} (${user.ShortID})` : user.ShortID} </option>
                  );
                })}
              </select>
            </div>
            <div className='sr__adminPanel__input'>
              <input
                className='sr__adminPanel__textField'
                id='score'
                inputMode='text'
                name='score'
                autoComplete='score'
                placeholder='Счет'
                type='text'
              />
            </div>
            <button
              className='sr__adminPanel__button'
              style={{ marginBottom: '0' }}
              onClick={() => AdminStore.onClickBeatSaber()}
            >Продолжить</button>
          </div>

          <div className="games_list">
            {AdminStore.beatSaberGames.map((game) => {
              return <div className="games_item" key={`${game.ID}_mobile`}>
                <div className="games_item-header" onClick={() => game.Opened = !game.Opened }>
                  <p>{getUser(game.UserID).length < 24 ? getUser(game.UserID) : `${getUser(game.UserID).slice(0, 25)}...`}</p>
                  <p>{game.Score}</p>
                </div>
                <div className="games_item-body" style={{ display: game.Opened ? 'block' : 'none' }}>
                  <p>ID: <b>{game.ID}</b></p>
                  <p>Игрок: <b>{getUser(game.UserID)}</b></p>
                  <p>Очки: <b>{game.Score}</b></p>
                </div>
              </div>
            })}
          </div>
          <div className="container" style={{ marginTop: '0' }}>
            <table className="games_table" style={{ marginTop: '0' }}>
              <thead>
                <tr className="games_table-header">
                  <th>ID</th>
                  <th style={{ width: '320px' }}>Игрок</th>
                  <th style={{ width: '360px' }}>Очки</th>
                </tr>
              </thead>
            </table>
            <div className="table-body">
              <table className="games_table">
                <tbody>
                  {AdminStore.beatSaberGames.map((game) => {
                    return <tr className="games_table-row" key={game.ID}>
                      <td className="table_column-id"><button onClick={() => AdminStore.deleteBeatsaber(game.ID)}>Удалить</button>{game.ID}</td>
                      <td style={{ width: '320px' }} className="table_column-user">{getUser(game.UserID)}</td>
                      <td style={{ width: '360px' }} className="table_column-map">{game.Score}</td>
                    </tr>
                  })}
                </tbody>
              </table>
            </div>
          </div>
          </> : <></>
        }
      </>
  );
});

export default AdminPanelPage;